import { TAX_EASE_ROUTER } from '~/constants/router';
import { openPageModal } from '~/utils/mobileApp';

import { ChevronRightIcon } from '~/assets/icons';

export function TaxEaseEntry() {
  const handleClick = () => {
    openPageModal(TAX_EASE_ROUTER.root);
  };

  return (
    <button
      type="button"
      className="flex justify-between bg-yellow-100 px-20 py-12"
      onClick={handleClick}
    >
      <p className="flex items-center gap-8 typo-paragraph100-semibold">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M12 2.25195C17.5228 2.25195 22 6.72911 22 12.252C22 17.7748 17.5228 22.252 12 22.252C6.47715 22.252 2 17.7748 2 12.252C2 6.72911 6.47715 2.25195 12 2.25195ZM17 8.62012C17 7.94349 16.3421 7.46218 15.6973 7.66699L6.69727 10.5312C6.28248 10.6633 6.00016 11.0481 6 11.4834V13.0215C6.00027 13.4567 6.28249 13.8426 6.69727 13.9746L9 14.707V17.8623C9.00028 18.0915 9.15652 18.2921 9.37891 18.3477L10.3789 18.5977C10.6941 18.6762 10.9996 18.4371 11 18.1123V15.3428L15.6973 16.8379C16.3419 17.0426 16.9997 16.5611 17 15.8848V8.62012Z"
            fill="#FFC700"
          />
        </svg>
        세무이지 서비스 정식 오픈! 무료 견적 받기
      </p>
      <ChevronRightIcon />
    </button>
  );
}
